import { useContext, useEffect } from 'react';
import Stack from '@mui/joy/Stack';
import Card from '@mui/joy/Card';
import Sheet from '@mui/joy/Sheet';
import ProjectSettings from './ProjectSettings';
import Link from './Link';

import Typography from '@mui/joy/Typography';
import Button from '@mui/joy/Button';
import Chip from '@mui/joy/Chip';

import { RootStoreContext } from '../stores/root_store';
import { observer } from 'mobx-react-lite';
import { getIcon } from 'utils/misc';
import useProject from 'hooks/useProject';
import useUserIdentity from 'hooks/useUserIdentity';

import { ListicleProjectHeader } from 'components/ListicleProject';

// type ProjectListProps = {
// };


function _ProjectList() {

	const rootStore = useContext(RootStoreContext);
	const { currentIdentity } = useUserIdentity();
    const { getIdentityProjects } = useProject();
    const projects = getIdentityProjects(currentIdentity.key);

    useEffect(() => {
		rootStore.projectStore.fetchIdentityProjects(currentIdentity.key);
		console.log('fetching projects');
		// everything...
    }, [rootStore.projectStore, currentIdentity.key]);

    const Icon = getIcon('Add');

	return (
		<Sheet
			sx={{
				// borderRight: '1px solid',
				// borderLeft: '1px solid',
				borderColor: 'divider',
				height: 'auto',
				overflowAnchor: 'none',
				display: 'flex',
				flexGrow: 1,
				flexDirection: 'column',
				flexShrink: 1,
			}}
		>
			<Stack direction="row" spacing={1} alignItems="center" p={2} pb={1.5}
				sx={{borderBottom: '1px solid', borderColor: 'divider'}}
			>
				<Typography
					fontSize={{ xs: 'md', md: 'lg' }}
					fontWeight="lg"
					endDecorator={
						<Chip
							variant="outlined"
							color="neutral"
							size="sm"
							slotProps={{ root: { component: 'span' } }}
						>
							{ projects.length }
						</Chip>
					}
					sx={{ mr: 'auto' }}
				>
					Projects
				</Typography>

                <Link to="/project/new">
                    <Button
                        variant="outlined"
                        startDecorator={<Icon />}
                        color="neutral" size="sm" >
                         New Project
                    </Button>
                    </Link>

			</Stack>

            { projects.length == 0 &&
                <Stack p={1}>
                <Card>
                <Stack alignItems="center" spacing={1}>


                <Typography
                    pt={1}
                    level="title-md"
                >Welcome!</Typography>

                <Typography
                    level="title-lg"
                >Let's get started.</Typography>


                    <Typography>
                        We need to create a project.
                    </Typography>
                    <Stack pt={2}>
                    <ProjectSettings simple={true} />
                    </Stack>

                    </Stack>
                </Card>
                    </Stack>
            }
            { projects.length > 0 &&
			    <Stack m={3}>
				{projects.map((project) => (
					<ListicleProjectHeader
						key={project.key}
						project={project}
                        showNew={false}
                    />
				))}
			</Stack>
            }
		</Sheet>
	);
}



const cp = observer(_ProjectList);
export default cp;
